<template>
    <b-modal
        :ref="modalRef"
        title-tag="h2"
        :title="'Unapply Credit'"
        lazy
        no-close-on-backdrop
        no-close-on-esc
    >
        <p>
            This invoice has been written off. Un-applying this credit will
            delete the write-off. Do you want to continue?
        </p>

        <template v-slot:modal-footer>
            <modal-footer
                :is-loading="isLoading"
                ok-title="Yes"
                @ok-action="save"
                @cancel-action="close"
            />
        </template>
    </b-modal>
</template>
<script type="text/javascript">
import InvoiceCreditService from "@/services/invoice/invoice-credit";

export default {
    components: {
        modalFooter: () => import("@/components/elements/modal-footer")
    },
    props: {
        modalRef: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            isLoading: false,
            invoiceId: null,
            creditId: null
        };
    },
    methods: {
        open(params) {
            this.invoiceId = params.invoice_id;
            this.creditId = params.credit_id;
            this.$refs[this.modalRef].show();
        },
        close() {
            this.isLoading = false;
            this.$refs[this.modalRef].hide();
        },
        async save() {
            try {
                this.isLoading = true;
                let response = await InvoiceCreditService.cancelCredit({
                    invoice_id: this.invoiceId,
                    credit_id: this.creditId
                });
                if (response.code == 200) {
                    this._message(response.message);
                    this.$emit("reload");
                    this.close();
                } else {
                    this.isLoading = false;
                    this._message(response.message, "danger");
                }
            } catch {
                this.isLoading = false;
                this._message("Error : Unable to cancel credit", "danger");
            }
        }
    }
};
</script>
